import { render } from "./IdentityExamine.vue?vue&type=template&id=44562b77&scoped=true"
import script from "./IdentityExamine.vue?vue&type=script&lang=js"
export * from "./IdentityExamine.vue?vue&type=script&lang=js"

import "./IdentityExamine.vue?vue&type=style&index=0&id=44562b77&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44562b77"]])

export default __exports__